import { DropletSep } from "./icons";
import { MARQUEE_ITEMS } from "@/lib/constants";

export default function MarqueeBar() {
  return (
    <div data-testid="hidropro-marquee-reforco" className="relative z-10 overflow-hidden border-y border-[#06202f] bg-brand-ink py-4">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((dup) => (
          <div key={dup} aria-hidden={dup === 1} className="flex items-center">
            {MARQUEE_ITEMS.map((item) => (
              <span
                key={`${dup}-${item}`}
                className="flex items-center whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.18em] text-white/90 sm:text-xs"
              >
                <span className="px-6 sm:px-8">{item}</span>
                <DropletSep className="h-3 w-3 shrink-0 text-water" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
